module.exports = __webpack_public_path__ + "static/img/one.d1ac959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/12/one.png
// module id = KUzg
// module chunks = 1